export let ExpressCheckoutButtonsState = /*#__PURE__*/function (ExpressCheckoutButtonsState) {
  ExpressCheckoutButtonsState["LOADING"] = "LOADING";
  ExpressCheckoutButtonsState["LOADED_WITHOUT_BUTTONS"] = "LOADED_WITHOUT_BUTTONS";
  ExpressCheckoutButtonsState["LOADED_WITH_BUTTONS"] = "LOADED_WITH_BUTTONS";
  return ExpressCheckoutButtonsState;
}({});
export function getState(_ref) {
  let {
    isLoading,
    shouldRender,
    numberOfButtons
  } = _ref;
  if (isLoading) {
    return ExpressCheckoutButtonsState.LOADING;
  }
  if (!shouldRender || numberOfButtons === 0) {
    return ExpressCheckoutButtonsState.LOADED_WITHOUT_BUTTONS;
  }
  return ExpressCheckoutButtonsState.LOADED_WITH_BUTTONS;
}
//# sourceMappingURL=ExpressCheckoutButtonsState.js.map